import { useService } from 'react-reservice';

import { getUseServiceWithSubscriptionKeys } from '@webtrader/core/utils';

import signalsService from './service';

export const useSignals = () => {
  return useService(signalsService, (state) => state);
};

export const useSignalsWithKeys = getUseServiceWithSubscriptionKeys(signalsService);

export { signalsService };
